import { render, staticRenderFns } from "./ViewerLoader.vue?vue&type=template&id=592701ba"
import script from "./ViewerLoader.vue?vue&type=script&lang=ts"
export * from "./ViewerLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports